<script setup lang="ts">
import { refDebounced } from "@vueuse/core";
import { computed, ref } from "vue";
import type { ClientFunctionItem } from "./ClientFunctionList.vue";
import ClientFunctionList from "./ClientFunctionList.vue";

const props = defineProps<{ items: ClientFunctionItem[] }>();
const emit = defineEmits<{ select: [id: string] }>();
const searchInput = ref<HTMLInputElement | null>(null);
const search = ref("");
const appliedSearch = refDebounced(search, 500);
const normalizeSearch = (value: string) => value.normalize("NFD").replace(/\p{M}/gu, "").toLocaleLowerCase("vi").replace(/đ/g, "d");
const filteredItems = computed(() => {
  const query = normalizeSearch(appliedSearch.value.trim());
  return props.items.filter((item) => normalizeSearch(item.label).includes(query)
    || item.keywords?.some((keyword) => normalizeSearch(keyword).includes(query)));
});

function focus() {
  searchInput.value?.focus();
}

defineExpose({ focus });
</script>

<template>
  <div class="flex min-h-0 flex-col gap-4">
    <input
      ref="searchInput"
      v-model="search"
      type="search"
      class="input input-bordered w-full"
      placeholder="Tìm chức năng..."
      aria-label="Tìm chức năng"
    />
    <ClientFunctionList :items="filteredItems" :highlight="appliedSearch" @select="emit('select', $event)" />
    <p v-if="filteredItems.length === 0" class="text-base-content/70" role="status">Không tìm thấy chức năng phù hợp.</p>
  </div>
</template>
